import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const statsig = defineConnector({
  identifier: "statsig",
  name: "Statsig",
  tagLine: "Feature flags and experimentation",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://statsigapi\\.net/.*",
  auth: (app) =>
    headerAuth([{ name: "STATSIG-API-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create a console API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Statsig console](https://console.statsig.com/), open **Project Settings › Keys & Environments** and create a **Console API** key.",
        },
      ],
    },
    {
      title: "Paste your console API key",
      items: [
        {
          kind: "input",
          label: "Console API key",
          placeholder: "console-...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://statsigapi.net/console/v1/gates",
  },
});
